import React from "react";
import { brandLogoFull, brandTagline } from "../brand";

// Branded full-screen boot/loading splash — matches the app background (#0D1812)
// so there is no seam between the OS launch screen, the static #ff-boot splash,
// and the running app.
export default function Splash({ label }) {
  return (
    <div
      className="fixed inset-0 z-[9998] flex flex-col items-center justify-center bg-ff-bg"
      data-testid="app-splash"
    >
      <img
        src={brandLogoFull}
        alt="Aurumward"
        className="w-[min(66vw,320px)] animate-fade-up object-contain"
      />
      <p className="mt-4 font-display text-lg italic text-ff-muted">{brandTagline}</p>
      <div className="mt-7 h-[3px] w-32 overflow-hidden rounded-full bg-ff-brass/20">
        <span className="animate-ffboot block h-full w-2/5 bg-ff-gold" />
      </div>
      {label && <p className="mt-3 text-xs uppercase tracking-widest text-ff-brass">{label}</p>}
    </div>
  );
}
